module.exports = __webpack_public_path__ + "static/img/qr.6af3be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/qr.png
// module id = ROGy
// module chunks = 1